import { FieldInputLength } from 'components/FieldInputLength';
import { SkillsMemberModel } from 'generated-types/skills/member';
import { ResumeProfileModel } from 'generated-types/skills/resume_profile';
import { Control, Controller, FieldErrorsImpl } from 'react-hook-form';
import { Input } from 'rsuite';
import { aboutMaxLength, EditProfileFormType, headlineMaxLength } from 'schema/skills/profile';

const ProfileEditForm = ({
    selectedResumeProfile,
    member,
    control,
    watchFields,
    errors,
}: {
    selectedResumeProfile: ResumeProfileModel;
    member: SkillsMemberModel;
    control: Control<EditProfileFormType>;
    watchFields: EditProfileFormType;
    errors: Partial<FieldErrorsImpl<EditProfileFormType>>;
}) => {
    return (
        <>
            <p>Headline</p>
            <Controller
                name="headline"
                control={control}
                defaultValue={selectedResumeProfile?.headline ?? ''}
                render={({ field }) => <Input as={'textarea'} rows={6} {...field} />}
            />
            <FieldInputLength
                currentLength={
                    watchFields.headline ? watchFields.headline.length : member.headline?.length
                }
                maxLength={headlineMaxLength}
            />
            {errors.headline?.message}
            <p>About</p>
            <Controller
                name="about"
                control={control}
                defaultValue={selectedResumeProfile?.about ?? ''}
                render={({ field }) => <Input as={'textarea'} rows={6} {...field} />}
            />
            <FieldInputLength
                currentLength={watchFields.about ? watchFields.about.length : member.about?.length}
                maxLength={aboutMaxLength}
            />
            {errors.about?.message}
        </>
    );
};

export default ProfileEditForm;
